"use client";

import { useEffect, useState } from "react";
import { CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ConfirmationCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  const [iconScale, setIconScale] = useState(0.8);
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => setIconScale(1), 100);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);
  return <section className="relative min-h-screen flex items-center justify-center bg-background px-4 py-16">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute inset-0" style={{
        backgroundImage: `repeating-linear-gradient(
              45deg,
              hsl(45, 90%, 50%),
              hsl(45, 90%, 50%) 10px,
              transparent 10px,
              transparent 20px
            )`
      }} />
      </div>

      <div ref={ref} className="relative w-full max-w-lg transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]" style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(20px)"
    }}>
        <Card className="shadow-medium border border-muted bg-background">
          <CardContent className="flex flex-col items-center text-center space-y-6 py-12">
            {}
            <div className="transition-transform duration-[var(--duration-slow)] ease-[var(--ease-spring)]" style={{
            transform: `scale(${iconScale})`
          }}>
              <CircleCheck className="size-16 text-primary" strokeWidth={1.5} />
            </div>

            <div className="space-y-3">
              <h1 className="text-3xl font-display font-semibold !text-[hsl(22,78%,26%)]">
                Consultation Booked
              </h1>
              <p className="text-muted-foreground text-base leading-relaxed max-w-md">
                Thank you for scheduling a consultation with Salem Ballama Auditing. 
                We will contact you shortly to confirm your appointment.
              </p>
            </div>

            {}
            <Link to="/HomePage">
              <Button className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-9 has-[>svg]:px-3 mt-4 text-foreground-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] px-8 py-3 rounded-md font-semibold !bg-[hsl(22,78%,26%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0">
                Return Home
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </section>;
}